// extracted by mini-css-extract-plugin
module.exports = {"dot":"Dot_dot_1c1J6"};